<template>
    <div class="bootstrap-wrapper main">
        <div class="container ">
            <div class="row d-flex justify-content-center mt-lg-5 mt-0">
                <div class="col-lg-6 px-lg-5 body rounded">
                    <div class="col-12 ">
                        <!-- Images -->
                        <div class="d-flex justify-content-between pb-5 pt-5">
                            <img class="customLogin-logo" src="../../assets/img/posadas-corporate.svg" v-bind:alt="$t('language.posadasCorporate.posadasCorporate')">
                            <section class="d-flex align-items-center">
                                <Languages />
                            </section>
                        </div>
                        <!-- From -->
                        <div class="">
                           <p class="subtitle pb-3">{{ $t('language.posadasCorporate.probAccesar.noAccess') }}</p>
                           <p class="">{{ $t('language.posadasCorporate.probAccesar.addData') }}</p><br>
                        </div>
                        <form @submit.prevent="handleSubmit">
                            <div class="form-element">
                                <label for="clientId">{{ $t('language.posadasCorporate.probAccesar.clientId') }}</label>
                                <div class="">
                                    <input type="text" @keydown.space.prevent v-model="user.clientId" id="clientId" name="clientId" class="form-control idInput" :class="{ 'is-invalid': submitted && $v.user.clientId.$error || !$v.user.clientId.maxLength }" >
                                    <div v-if="submitted && !$v.user.clientId.required" class="invalid-feedback">{{ $t('language.posadasCorporate.probAccesar.invalid') }}</div>
                                    <span class="invalid-feedback" v-if="!$v.user.clientId.maxLength">
                                        {{$t('language.posadasCorporate.login.mayor1')}} {{$v.user.clientId.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}}
                                    </span>
                                </div>
                            </div>
                            <div class="form-element ">
                                <label for="userName">{{ $t('language.posadasCorporate.probAccesar.user') }}</label>
                                <div class="">
                                    <input type="text" @keydown.space.prevent v-model="user.userName" id="userName" name="userName" class="form-control minuscula" :class="{ 'is-invalid': submitted && $v.user.userName.$error || !$v.user.userName.maxLength  }">
                                    <div v-if="submitted && !$v.user.userName.required" class="invalid-feedback">{{ $t('language.posadasCorporate.probAccesar.userName') }}</div>
                                    <span class="invalid-feedback" v-if="!$v.user.userName.maxLength">
                                       {{$t('language.posadasCorporate.login.mayor3')}} {{$v.user.userName.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}}
                                    </span>
                                </div>
                            </div>
                            <div class="form-element ">
                                <label for="email">{{ $t('language.posadasCorporate.probAccesar.email') }}</label>
                                <div class="">
                                    <input type="mail" @keydown.space.prevent v-model="user.email" id="email" name="email" class="form-control" :class="{ 'is-invalid': (submitted && $v.user.email.$error || !$v.user.email.maxLength )}"  />
                                    
                                    <div v-if="(submitted && $v.user.email.$error) || !$v.user.email.maxLength" class="invalid-feedback">
                                        <span v-if="!$v.user.email.required">{{ $t('language.posadasCorporate.probAccesar.invalid2') }}.</span>
                                        <span v-if="!$v.user.email.email">{{ $t('language.posadasCorporate.probAccesar.invalid3') }}.</span>
                                        <span v-if="!$v.user.email.maxLength"> {{$t('language.posadasCorporate.login.mayor6')}} {{$v.user.email.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}}</span>
                                  
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="form-element ">
                                <label>{{ $t('language.posadasCorporate.probAccesar.level') }}</label><br>
                                <span class="col-3 pl-0">
                                    <input type="radio" id="admin" value="Administrador" v-model="user.picked">
                                    <label class="pl-1 labelCheck" for="admin"> {{ $t('language.posadasCorporate.probAccesar.administrator') }}</label>
                                </span>
                                <span class="col-3">
                                    <input type="radio" id="agent" value="Agente" v-model="user.picked">
                                    <label class="pl-1 labelCheck" for="agent">{{ $t('language.posadasCorporate.probAccesar.agent') }}</label>
                                </span>
                                <div v-if="submitted && $v.user.picked.$error" class="invalid-feedback">
                                    <span v-if="!$v.user.picked.required">{{ $t('language.posadasCorporate.probAccesar.newOption') }}</span>
                                </div>
                            </div>
                            <div class="pt-4">
                                <p class="subtitle">{{ $t('language.posadasCorporate.probAccesar.comments') }}</p>

                                <div class="pb-2">
                                    <textarea rows="7"  v-model="user.comentario" id="comentario" name="comentario" class="form-control" :class="{ 'is-invalid': !$v.user.comentario.maxLength }"></textarea>
                                    <div class="invalid-feedback" v-if="!$v.user.comentario.maxLength">
                                        <span>
                                       {{$t('language.posadasCorporate.login.mayor5')}} {{$v.user.comentario.$params.maxLength.max}} {{$t('language.posadasCorporate.login.mayor2')}} </span>
                                    </div>
                                </div>
                                <div>
                                    <p>{{ $t('language.posadasCorporate.probAccesar.co') }}</p>
                                </div>
                            </div>
                            <Loader v-if="banLoader" />
                            <div class="row py-5">
                                <div class="col-md-6 order-md-1 order-2">
                                    <router-link class="subtitle colorBlue" to="/login"><button class="secondary-button" >{{ $t('language.posadasCorporate.probAccesar.return') }}</button></router-link>
                                </div>
                                <div class="col-md-6 order-md-2 order-1">
                                    <button :disabled="isDisabled || banLoader" class="mb-md-0 mb-3">{{ $t('language.posadasCorporate.probAccesar.send') }}</button>
                                </div>
                            </div>
                        </form>
                    </div>
              
          </div>
      </div>
    </div>

    <modal v-if="banModal" @close="closeModalE" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ titleModalExito }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
            {{ $t("language.posadasCorporate.probAccesar.continuity") }}
        </p>
        <p class="Ta-left">
          <b>{{ $t("language.posadasCorporate.probAccesar.continuityCode") }}{{folioModal}}</b>
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeModalE"
          aria-label="Close modal">
          {{ $t("language.posadasCorporate.modales.alertExito.aceptar") }}
        </button>
      </template>
    </modal>

    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.login.WSError') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.login.textoModal1') }} 
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="aceptarHotemlModal()"
          aria-label="Close modal">
          {{ $t('language.posadasCorporate.login.entendido') }}
        </button>
      </template>
    </modal>

  </div>
</template>

<script>
import * as GlobalFunctions from '../../utils/GlobalFunctions';
import Languages from '../languages/Languages';
import { required, email, maxLength } from "vuelidate/lib/validators";
import i18n from '../../plugins/i18n'
import axios from 'axios';
import SecureLS from 'secure-ls'
import Router from 'vue-router'
import Modal from '../addons/Modal.vue'
import Loader from '../loader/Loader';

export default {
    name: 'Problemas',
    components: {
      Languages,
      Modal,
      Loader
    },
    data: () => {
      return {
        banLoader: false,
        banModal: false,
        titleModalExito: '',
        folioModal: 0,
        isModalVisible: false,
        temp: '',
        user: {
          clientId: "",
          userName: "",
          email: "",
          picked: "",
          comentario: "",
          isAgent: ""
        },
        language: '',
        messageWS: '',
        submitted: false,
      }
    },
    validations: {
      user: {
        clientId: { required, maxLength: maxLength(20) },
        userName: { required, maxLength: maxLength(20) },
        email: { required, email, maxLength: maxLength(50) },
        picked: { required },
        comentario: { maxLength: maxLength(255) },
      }
    },
    methods: {
      closeModalE(){
        this.banModal = false;
        this.$router.push({ name: 'Login'})
      },
      closeModal() {
        this.isModalVisible = false;
      },
      handleSubmit(e) {
        this.banLoader = true;
        this.submitted = true;
        var ls = new SecureLS({encodingType: 'aes'});
        var AESEncryption1 = ls.get('Language')
        const formData = {
          clientId: this.user.clientId,
          user: this.user.userName.toLowerCase(),
          email: this.user.email,
          isAgent: this.user.picked,
          comments: this.user.comentario
        }
          
        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.exito(formData, this.language)
      },
      exito(a, language)  {
        var ls = new SecureLS({encodingType: 'aes'});
        language = ls.get('Language'); // localStorage.getItem('Language');
        if (language.data == 'es') {
        } else {
          if (a.isAgent == 'Administrador') {
            a.isAgent = 'Administrator'
          } else {
            a.isAgent = 'Agent'
          }
        }
        var messageT = ''
        // Here starts my fetch call which will be replaced by an axios call so let's get started            
        const router = this.$router
        axios.post(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_PROBLEMACCESS, {
          profileId: a.user,
          email:a.email,
          userId:a.clientId.toUpperCase(),
          userType:a.isAgent, // This has to change with language also
          isCredit:"Activo",
          comments:a.comments
        }, {
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Accept-language': language.data,
            'Content-Type': 'application/json',
          }
        })
        .then(res => {
          if (res.status == 200 || res.status == 201) {
            /**
             * servicio respondio con exito con status 200
             * redirecciona al login
             */
            this.banLoader = false;
            this.banModal = true;
            this.titleModalExito = res.data.message;
            this.folioModal = res.data.response;
          }
        })
        .catch(error => {
          // Error server
          this.banLoader = false;
             let errorObject=JSON.parse(JSON.stringify(error));
 if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
  this.$router.push({ name: "Error2" });
} 
// Error server 
  else{
            const response = error.response
            this.isModalVisible = true
          }
        }); 
      },
      setLocale(locale) {
        this.$i18n.locale = locale;
        this.switchHidden();
      }
    },
    computed: {
      isDisabled() {
        if (this.user.clientId.length > 1 && this.user.userName.length > 1 && this.user.email.length > 1 
          && this.$v.user.userName.maxLength && this.$v.user.clientId.maxLength && this.$v.user.email.maxLength
          && this.user.picked != '') {
          return false;
        } else {
            return true;
        }
      },
      isActive() {
        if(Object.keys(this.picked).length === 0 ){
            return ''
        } else {
            return 'labelCheck'
        }
      }
    },
    created() {},
    beforeMount() {
      GlobalFunctions.tokenExistValidate().then(response => {
        if(response){
          this.$router.push({ name: "Reservaciones" });                
        }
      });
    },
}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/config.scss';

  .minuscula {
    text-transform: lowercase;
  }
  .icon-check-rounded:before {
    content: '\E817';
    font-weight: bolder;
  }

  .labelCheck {
    color: $grayBrownish;
    font-size: $font-size-base;
    font-weight: 300;
  }

  input[type="radio"]:checked~label {
    color: $grayShadeDark;
    font-size: $font-size-base;
    font-weight: normal;
  }

</style>
